import { Center, Stack, Title, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function CompanyScreenInitial() {
    const { t } = useTranslation();
    return (
        <Center h="100%">
            <Stack>
                <Title color="dimmed" align="center" order={2}>
                    {t('screen.companies.seeComapnyProfiles')}
                </Title>
                <Text color="dimmed" align="center">
                    {t('screen.companies.selectCompany')}
                </Text>
            </Stack>
        </Center>
    );
}
